import { type EmbedCSSStyles, type EmbedTarget } from '..'
import { isZeroValue } from '../../utils/dom-style'
import { ElementStyleSetSwitcher } from './element-style-control'

export interface EmbedStylesOption<STYLES = EmbedCSSStyles | (() => EmbedCSSStyles) | undefined> {
  styles?: {
    overlay?: STYLES
    teleport?: STYLES
  }
  baseStyles?: STYLES
}

export class EmbedStyleControl {
  styleSwitcher: ElementStyleSetSwitcher
  constructor (el: HTMLElement, opts?: EmbedStylesOption) {
    this.styleSwitcher = new ElementStyleSetSwitcher(el)
    this.styleSwitcher.addStyleSet('overlay', opts?.styles?.overlay ?? {})
    this.styleSwitcher.addStyleSet('teleport', opts?.styles?.teleport ?? {})
    this.styleSwitcher.applyStyles(opts?.baseStyles ?? {})
  }

  updateStyle (styleName: 'overlay' | 'teleport') {
    this.styleSwitcher.applyStyleSet(styleName)
  }
}

export class DefaultEmbedStyleControl extends EmbedStyleControl {
  constructor (embedTarget: EmbedTarget, el: HTMLElement, opts?: EmbedStylesOption<EmbedCSSStyles | undefined>) {
    super(el, {
      baseStyles: opts?.baseStyles,
      styles: {
        teleport: Object.assign({
          width: embedTarget.ctx.settings.teleport?.width ?? '100%',
          height: embedTarget.ctx.settings.teleport?.height ?? '250px',
          position: '',
          top: '',
          left: ''
        }, embedTarget.ctx.settings.teleport?.style, opts?.styles?.teleport),
        overlay: () => (Object.assign({
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: embedTarget.bottomSpace != null && !isZeroValue(embedTarget.bottomSpace) ? `calc(100% - ${embedTarget.bottomSpace})` : '100%'
        }, embedTarget.ctx.settings.style, opts?.styles?.overlay))
      }
    })
  }
}
